import axios from '@/plugins/axios'

export default {
  async send(data) {
    return await axios.post('contact', data)
  },
}
